import React from 'react';

import * as yup from 'yup';
import i18n from 'i18n-js';
import { Form, Formik } from 'formik';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import { DialogActions } from '@material-ui/core';

import { Input } from 'components/shared';
import { MenuType } from 'constants/enums';

interface AddSectionProps {
    isVisible: boolean;
    onClose: () => void;
    onAdd: (sectionName: string, price: number) => void;
    sections: string[];
    menuType: MenuType;
}

export default function AddSectionModal(props: AddSectionProps) {
    const validationSchema = yup.object().shape({
        name: yup
            .string()
            .required(
                i18n.t('form.errors.required', {
                    name: 'Name',
                })
            )
            .test(
                'existsCheck',
                i18n.t('form.errors.alreadyTaken'),
                (value: any) => !props.sections.includes(value?.toUpperCase())
            ),
        price: yup.number().min(0, i18n.t('form.errors.positiveNumber')),
    });

    return (
        <Dialog open={props.isVisible} aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">{i18n.t('common.addSection')}</DialogTitle>
            <DialogContent>
                <DialogContentText>{i18n.t('common.enterSectionName')}</DialogContentText>
                <Formik
                    initialValues={{
                        name: '',
                        price: 0,
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values, { resetForm }) => {
                        props.onAdd(values.name, values.price);
                        resetForm();
                    }}
                >
                    {({ errors, submitForm }) => (
                        <Form>
                            <>
                                <br />
                                <Input
                                    error={errors.name}
                                    variant="filled"
                                    fullWidth={true}
                                    name={`name`}
                                    type="text"
                                    label={i18n.t('form.name')}
                                    placeholder={i18n.t('form.name')}
                                />
                                {props.menuType === MenuType.MultiCourse && (
                                    <Input
                                        error={errors.price}
                                        variant="filled"
                                        fullWidth={true}
                                        name={`price`}
                                        type="number"
                                        label={i18n.t('form.price')}
                                        placeholder={i18n.t('form.price')}
                                    />
                                )}
                            </>
                            <DialogActions>
                                <Button type="button" color="primary" onClick={props.onClose}>
                                    {i18n.t('button.cancel')}
                                </Button>
                                <Button onClick={submitForm} variant="contained" color="primary">
                                    {i18n.t('common.add')}
                                </Button>
                            </DialogActions>
                        </Form>
                    )}
                </Formik>
            </DialogContent>
        </Dialog>
    );
}
